export default function chooseNextProperId(ids) {
  if (ids.length === 0) return 1
  return Math.max.apply(null, ids) + 1
}



// WEBPACK FOOTER //
// ./src/helpers/chooseNextProperId.js